/**
 *
 * Asynchronously loads the component for PhotographerDetail
 *
 */

import loadable from 'utils/loadable';

export default loadable(() => import('./index'));
